/* eslint-disable */

import request from '@/utils/request'

export function getListBusinessShiftApi() {
  return request({
    url: '/config-service/v1/business-district-shift/list',
    method: 'get'
  })
}
export function getBusinessShiftByIdApi(id) {
  return request({
    url: `/config-service/v1/business-district-shift/select-one/${id}`,
    method: 'get'
  })
}

export function addBusinessShiftApi(query) {
  return request({
    url: '/config-service/v1/business-district-shift/',
    method: 'post',
    data: query
  })
}

export function updateBusinessShiftApi(query) {
  return request({
    url: `/config-service/v1/business-district-shift/`,
    method: 'put',
    data: query
  })
}
export function deleteBusinessShiftApi(query) {
  return request({
    url: '/config-service/v1/business-district-shift/',
    method: 'delete',
    data: query
  })
}
